// AXIOM — ranking presentation model
//
// The TRAIDENT SDK only gives the game a projected board and a score receipt.
// This module turns those trusted values into short, non-speculative copy before
// PortalOverlay creates DOM nodes. Keeping it free of DOM and transport code
// makes every player-facing state deterministic to test.

const asEntries = (board) => Array.isArray(board?.entries) ? board.entries : [];

export function rankingView(board, score) {
  const publicRead=board?.source==='TRAIDENT_PUBLIC';
  const hasBoard = Array.isArray(board?.entries);
  const entries = asEntries(board).slice(0, 3).map((entry) => ({
    rank: Number(entry?.rank) || 0,
    name: String(entry?.displayName ?? ''),
    score: Number(entry?.scoreValue) || 0,
    isMe: entry?.isMe === true,
  }));
  const mine = board?.myEntry || null;
  const state = String(score?.state || (board?.state === 'unavailable' ? 'unavailable' : hasBoard ? 'idle' : 'loading'));

  const status = publicRead && state==='unavailable'
    ? {kind:'unavailable',label:'ランキング',text:'取得できませんでした。再読込してください。'}
    : statusFor(state, score);
  const player = !mine && board?.source==='TRAIDENT_DIRECT'
    ? {kind:'unknown',label:'あなたの記録',value:'本人順位は未確認',score:null,note:'接続済み。送信結果は上に表示します。公開順位の参加設定はアカウント設定へ。'}
    : mine
    ? {
      kind: 'signed-in',
      label: 'あなたの記録',
      value: `${Number(mine.rank) || 0}位`,
      score: `${Number(mine.scoreValue) || 0}桁`,
      note: 'TRAIDENTランキングに掲載中',
    }
    : {
      kind: 'guest',
      label: 'あなたの記録',
      value: publicRead ? '未接続' : 'ゲスト',
      score: null,
      note: publicRead?'「ランキングに接続」後のプレイから記録を送信します':'パスキーで保護すると公開ランキングの対象になります',
    };

  return {
    state,
    publicRead,
    track: board?.track || 'STANDARD',
    playUrl: board?.playUrl || null,
    status,
    entries,
    empty: hasBoard && entries.length === 0,
    player,
    direction: '確認先: TRAIDENT ランキング',
    ticket: 'Gold Ticketは、既存1位を上回った記録をTRAIDENTが判定・付与します。AXIOMでは発行・当選判定しません。',
  };
}

function statusFor(state, score) {
  const magnitude = Number(score?.magnitude);
  const magnitudeText = Number.isFinite(magnitude) ? `${magnitude}桁` : '記録';
  if (state === 'loading') return { kind: 'loading', label: 'ランキング', text: 'ランキングを読み込み中' };
  if (state === 'unavailable') return { kind: 'unavailable', label: 'ランキング', text: '現在のランキングを取得できません。TRAIDENTで確認してください。' };
  if (state === 'sending') return { kind: 'sending', label: '送信結果', text: `${magnitudeText}を送信中` };
  if (state === 'accepted') {
    if (String(score?.verificationStatus).toUpperCase() === 'VERIFIED') {
      return { kind: 'accepted', label: '送信結果', text: `確認済み。${magnitudeText}はランキング反映待ちです。` };
    }
    return { kind: 'accepted', label: '送信結果', text: `送信を受理しました。${magnitudeText}をTRAIDENTが検証中です。` };
  }
  if (state === 'failed' || state === 'rejected') return { kind: 'rejected', label: '送信結果', text: '記録を送信できませんでした。次のプレイでもう一度挑戦できます。' };
  if (state === 'refresh-failed') return { kind: 'accepted', label: '送信結果', text: '送信は受理済みです。ランキングはTRAIDENTで確認してください。' };
  if (state === 'refreshed') {
    if (score?.claimRequired) return { kind: 'accepted', label: '送信結果', text: '記録を保存しました。パスキーで保護すると公開ランキングの対象になります。' };
    if (score?.myScore !== null && score?.myScore !== undefined) return { kind: 'refreshed', label: '送信結果', text: `ランキングを更新しました。自己ベスト ${score.myScore}桁を確認。` };
    return { kind: 'accepted', label: '送信結果', text: '送信は受理済みです。ランキング反映はTRAIDENTで確認してください。' };
  }
  return { kind: 'idle', label: 'ランキング', text: '現在のランキングを表示' };
}
